// extracted by mini-css-extract-plugin
export default {"topBtn":"ToTop_topBtn__VS-dN"};